export class UserType{
    static GUEST = "guest"
    static MERCHANT = "merchant"
    static CUSTOMER = "customer"
}